/**
 * created by：li si yi
 * 稿件统计
 */
import React, {Component} from 'react';
import PMSStoryStatisticsSMG from './PMSStoryStatisticsSMG'
import BaseComponent from "../../../../base/BaseComponent";


export default class PMSStoryStatisticsSMGComponents extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={'ActivityPendingComponents StaticMyDeskItemPaddingTop'}>
                <div style={{background: '#fff', borderRadius: '5px', height: '300px'}}>
                    <div style={{
                        height: 45,
                        lineHeight: '45px',
                        background: 'white',
                        width: '100%',
                        float: 'left',
                        borderBottom: '1px solid #ebebeb',
                        borderTopLeftRadius: '5px',
                        borderTopRightRadius: '5px'
                    }}>
                        <div style={{paddingLeft: 20, float: 'left', color: '#000', fontSize: '16px'}}>
                            投稿统计
                        </div>
                    </div>
                    <div style={{clear: 'both'}}/>
                    <PMSStoryStatisticsSMG
                        topBtnClick={(data) => {
                            console.log('点击按钮', data)
                        }}
                        option={this.state.option}
                    />
                    <style>
                        {`
                            .ActivityPendingComponents .ant-radio-button-wrapper{
                              padding:0 7px;
                            }
                        `}
                    </style>
                </div>
            </div>
        )
    }
}